package org.zest.insan_360_website.data.page_states.dashboard

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch
import org.zest.insan_360_website.components.widgets.ToastState
import org.zest.insan_360_website.components.widgets.ToastType
import org.zest.insan_360_website.data.LanguageSettings
import org.zest.insan_360_website.data.localized
import org.zest.insan_360_website.data.page_states.AuthState
import org.zest.insan_360_website.model.SupAdmAdminsInfoPayload
import org.zest.insan_360_website.model.SupAdmVerifyRequest
import org.zest.insan_360_website.model.SuperAdminRequest
import org.zest.insan_360_website.model.UserRole
import org.zest.insan_360_website.utils.NetworkUtils
import org.zest.insan_360_website.utils.processResponse

object AdminsDashboardState {
    var adminsInfoState by mutableStateOf<SupAdmAdminsInfoPayload?>(null)
    var isLoading by mutableStateOf(false)
    var isVerifying by mutableStateOf(false)
    var needUpdate by mutableStateOf(true)

    var searchQuery by mutableStateOf("")

    fun reset() {
        adminsInfoState = null
        isLoading = false
        isVerifying = false
        needUpdate = true
        searchQuery = ""
    }

    fun fetchAdminsInfo(scope: CoroutineScope, toast: ToastState) {
        val role = AuthState.role
        if (role != UserRole.SUPER_ADMIN) return
        val email = AuthState.email ?: return
        if (AuthState.token == null) return

        isLoading = true

        scope.launch {
            try {
                val request = SuperAdminRequest<Unit>(
                    email = email,
                    role = role
                )
                val response = NetworkUtils.postSecureApi("/api/super-admin/dashboard/admins", request)
                    ?: throw Exception(
                        LanguageSettings.ResponseError.session_expired.localized
                    )

                adminsInfoState = processResponse(response, fallbackErrorLog = "Error fetching admins info")

            } catch (e: Exception) {
                console.error(e)
                toast.show(
                    e.message ?: LanguageSettings.General.networkFailure.localized,
                    ToastType.ERROR
                )
            } finally {
                isLoading = false
            }
        }
    }

    fun verifyAdmin(adminId: String, toast: ToastState, scope: CoroutineScope, onSuccess: () -> Unit) {
        val role = AuthState.role
        if (role != UserRole.SUPER_ADMIN) return
        val email = AuthState.email ?: return
        if (AuthState.token == null) return

        isVerifying = true
        scope.launch {
            try {
                val request = SuperAdminRequest(
                    email = email,
                    role = role,
                    request = SupAdmVerifyRequest(
                        adminId = adminId
                    )
                )
                val response = NetworkUtils.postSecureApi("/api/super-admin/verify-admin", request)
                    ?: throw Exception(
                        LanguageSettings.ResponseError.session_expired.localized
                    )

                processResponse(response, toast, "Error verifying admin") { onSuccess() }

            } catch (e: Exception) {
                console.error(e)
                toast.show(
                    e.message ?: LanguageSettings.General.networkFailure.localized,
                    ToastType.ERROR
                )
            } finally {
                isVerifying = false
            }
        }
    }
}